import React from 'react'
import {Box, Typography} from '@mui/material'
import {IPassengerChartRouteSummary} from '@containers/monitoringPlatform/passengerCharts/types'
import RouteCard from '@containers/monitoringPlatform/passengerCharts/overview/RouteCard'
import sx from '@containers/monitoringPlatform/passengerCharts/overview/sx'

interface IProps {
	routes: IPassengerChartRouteSummary[]
	isLoading: boolean
	onSelectRoute: (routeId: number) => void
}

const RouteCardsOverview = ({routes, isLoading, onSelectRoute}: IProps) => {
	const countsMissing = routes.length > 0 && routes.every((r) => !r.countsAvailable)

	return (
		<Box>
			<Typography sx={sx.title}>Усі маршрути з відстеженням</Typography>

			{countsMissing && <Typography sx={sx.note}>Немає даних підрахунку</Typography>}

			{!isLoading && !routes.length && <Typography sx={sx.note}>
				Немає маршрутів з відстеженням за цей день
			</Typography>}

			<Box sx={sx.grid}>
				{routes.map((route) => (
					<RouteCard key={route.routeId} route={route} onSelect={() => onSelectRoute(route.routeId)}/>
				))}
			</Box>
		</Box>
	)
}

export default RouteCardsOverview
